import React from "react";

interface ActivityItemProps {
  id: number;
  type: string;
  icon: string;
  title: string;
  description: string;
  equipment: string;
  location: string;
  technician: string;
  time: string;
  status: string;
  invoice?: boolean;
  numberInvoice?: string;
  priceInvoice?: number;
}

const ActivityItem: React.FC<ActivityItemProps> = ({
  icon,
  title,
  description,
  equipment,
  location,
  technician,
  time,
  status,
  invoice,
  numberInvoice,
  priceInvoice,
}) => {
  return (
    <li className="activity-item">
      <div className="activity-icon">{icon}</div>
      <div className="activity-content">
        <div className="activity-header">
          <h4>{title}</h4>
          <span className="activity-time">{time}</span>
        </div>
        <p className="activity-description">{description}</p>
        <div className="activity-details">
          <span className="activity-detail">
            <strong>Equipo:</strong> {equipment}
          </span>
          <br />
          <span className="activity-detail">
            <strong>Ubicación:</strong> {location}
          </span>
          <br />

          <span className="activity-detail">
            <strong>Técnico:</strong> {technician}
          </span>
          <br />

          {invoice && numberInvoice && (
            <span className="activity-detail">
              <strong>Factura:</strong> {numberInvoice}
              {priceInvoice && ` - $${priceInvoice.toFixed(2)}`}
            </span>
          )}
        </div>
        <div className="activity-status">
          <span
            className={`status-badge status-${status
              .toLowerCase()
              .replace(/\s/g, "-")}`}
          >
            {status}
          </span>
        </div>
      </div>
    </li>
  );
};

export default ActivityItem;
